"use client";

import React, { useState } from 'react';
import { Steps, Button, message, Popover } from 'antd';
import type { StepsProps } from 'antd';
import ProjectSelect from "../select/ProjectSelect";
import ProjectForm from '../form/ProjectFormBis';

const { Step } = Steps;

const customDot: StepsProps['progressDot'] = (dot, { status, index }) => (
  <Popover
    content={
      <span>
        step {index} status: {status}
      </span>
    }
  >
    {dot}
  </Popover>
);

export default function ProjectWrapper() {
  const [currentStep, setCurrentStep] = useState<number>(0);

  const next = () => {
    setCurrentStep(currentStep + 1);
  };

  const prev = () => {
    setCurrentStep(currentStep - 1);
  };

  const registerSteps = [
    {
      title: "Select Project",
      content: (
        <ProjectSelect
          next={next}
          prev={prev}
        />
      ),
    },
    {
      title: "Fill Form",
      content: (
        <ProjectForm
          prev={prev}
          next={next}
        />
      ),
    },
    {
      title: "Confirmation",
      content: (
        <div style={{ textAlign: "center", marginTop: 50 }}>
          <h2>Confirmation</h2>
          <p>Your project and form have been successfully submitted!</p>
          <Button type="primary" onClick={() => setCurrentStep(0)}>
            Start Over
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div style={{ marginTop: 50, padding: 50 }}>
      <Steps current={currentStep} style={{ marginBottom: 20 }}>
        {registerSteps.map((item) => (
          <Step key={item.title} title={item.title} />
        ))}
      </Steps>
      {registerSteps[currentStep].content}
    </div>
  );
}
